(function () {
  var stages = document.querySelectorAll('.sb-agent__showcase-stage');
  if (!stages.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  stages.forEach(function (stage) {
    var section = stage.closest('section') || stage;
    var tabs = stage.querySelector('.sb-agent__showcase-tabs');
    var radios = stage.querySelectorAll('.sb-agent__show-radio');
    if (!tabs || !radios.length) return;

    var stopped = false;
    var hovering = false;
    var focusing = false;
    var visible = false;
    var advancing = false;

    function activeIndex() {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return i;
      }
      return 0;
    }

    function scrollActive() {
      var radio = radios[activeIndex()];
      var label = radio && tabs.querySelector('label[for="' + radio.id + '"]');
      if (!label) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      label.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    }

    function sync() {
      if (stopped || reduceMotion || radios.length < 2) {
        tabs.dataset.auto = 'off';
        return;
      }
      tabs.dataset.auto = hovering || focusing || !visible ? 'paused' : 'run';
    }

    sync();

    tabs.addEventListener('mouseenter', function () {
      hovering = true;
      sync();
    });
    tabs.addEventListener('mouseleave', function () {
      hovering = false;
      sync();
    });
    tabs.addEventListener('focusin', function () {
      focusing = true;
      sync();
    });
    tabs.addEventListener('focusout', function (event) {
      if (!tabs.contains(event.relatedTarget)) {
        focusing = false;
        sync();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        sync();
      });
      observer.observe(section);
    } else {
      visible = true;
      sync();
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        scrollActive();
        if (advancing) return;
        stopped = true;
        sync();
      });
    });

    tabs.addEventListener('animationend', function (event) {
      if (event.animationName !== 'sb-agent-tab-fill') return;
      if (stopped || reduceMotion || tabs.dataset.auto === 'off') return;
      var next = (activeIndex() + 1) % radios.length;
      advancing = true;
      radios[next].checked = true;
      radios[next].dispatchEvent(new Event('change', { bubbles: true }));
      advancing = false;
    });
  });
})();

(function () {
  var nodes = document.querySelectorAll('.sb-agent__countdown[data-deadline]');
  if (!nodes.length) return;

  var live = [];

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function hideCountdown(el) {
    el.classList.remove('is-ready');
    var wrap = el.closest('.sb-agent__plan-deadline-block');
    if (wrap) wrap.hidden = true;
  }

  function expireCompare(el) {
    var compare = el.closest('.sb-agent__compare[data-state="early"]');
    if (!compare) return;
    compare.setAttribute('data-state', 'regular');
    compare.querySelectorAll('[data-sb-when]').forEach(function (node) {
      node.hidden = node.getAttribute('data-sb-when') !== 'regular';
    });
  }

  nodes.forEach(function (el) {
    var end = new Date(el.getAttribute('data-deadline'));
    if (isNaN(end.getTime())) {
      hideCountdown(el);
      return;
    }
    if (end.getTime() <= Date.now()) {
      hideCountdown(el);
      expireCompare(el);
      return;
    }
    el._sbEnd = end.getTime();
    live.push(el);
  });

  if (!live.length) return;

  function tick() {
    var now = Date.now();
    live = live.filter(function (el) {
      var remaining = el._sbEnd - now;
      if (remaining <= 0) {
        hideCountdown(el);
        expireCompare(el);
        return false;
      }
      var total = Math.floor(remaining / 1000);
      var days = el.querySelector('[data-unit="d"]');
      var hours = el.querySelector('[data-unit="h"]');
      var minutes = el.querySelector('[data-unit="m"]');
      var seconds = el.querySelector('[data-unit="s"]');
      var boxes = el.getAttribute('data-format') === 'boxes';
      if (days) {
        days.textContent = boxes
          ? pad(Math.floor(total / 86400))
          : Math.floor(total / 86400) + ' ngày';
      }
      if (hours) hours.textContent = pad(Math.floor((total % 86400) / 3600));
      if (minutes) minutes.textContent = pad(Math.floor((total % 3600) / 60));
      if (seconds) seconds.textContent = pad(total % 60);
      el.classList.add('is-ready');
      return true;
    });
    if (!live.length) clearInterval(timer);
  }

  tick();
  var timer = setInterval(tick, 1000);
})();

(function () {
  var bar = document.querySelector('.sb-agent__quickbar');
  if (!bar) return;

  var root = bar.closest('.sb-agent');
  var hero = root ? root.querySelector('.sb-agent__hero-band') : null;
  var pricing = root ? root.querySelector('#sb-buy') : null;
  var heroIn = !!hero;
  var pricingIn = !!pricing;

  function syncPad() {
    if (!root) return;
    root.style.setProperty('--sb-quickbar-pad', bar.offsetHeight + 'px');
  }

  function sync() {
    var show = !heroIn && !pricingIn;
    bar.classList.toggle('is-visible', show);
    if (show) {
      bar.removeAttribute('inert');
      bar.removeAttribute('aria-hidden');
    } else {
      bar.setAttribute('inert', '');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  function syncObstruction() {
    if (!window.matchMedia('(max-width: 999px)').matches) {
      bar.style.removeProperty('--sb-quickbar-obstruction');
      return;
    }
    var preview = document.getElementById('PBarNextFrameWrapper');
    var block = 0;
    if (preview) {
      var rect = preview.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom >= window.innerHeight - 1) block = rect.height;
    }
    bar.style.setProperty('--sb-quickbar-obstruction', block + 'px');
  }

  syncPad();
  syncObstruction();
  if ('ResizeObserver' in window) {
    new ResizeObserver(syncPad).observe(bar);
    var previewBar = document.getElementById('PBarNextFrameWrapper');
    if (previewBar) new ResizeObserver(syncObstruction).observe(previewBar);
  }
  window.addEventListener('resize', function () {
    syncPad();
    syncObstruction();
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target === hero) heroIn = entry.isIntersecting;
      if (entry.target === pricing) pricingIn = entry.isIntersecting;
    });
    sync();
  }, { threshold: 0 });

  if (hero) observer.observe(hero);
  if (pricing) observer.observe(pricing);
  sync();
})();

(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAGGER_MS = 150;
  var SKILLS_DELAY_MS = 1000;

  function belowFold(el) {
    return el.getBoundingClientRect().top >= window.innerHeight;
  }

  function lightRows(rows, done) {
    var i = 0;
    function step() {
      if (i >= rows.length) {
        if (done) done();
        return;
      }
      rows[i].classList.remove('is-armed');
      i += 1;
      window.setTimeout(step, STAGGER_MS);
    }
    step();
  }

  function initLink(link) {
    if (!link || link.dataset.sbToolbeltReady === 'true') return;
    link.dataset.sbToolbeltReady = 'true';

    var section = link.closest('section') || link;
    var toolRows = Array.prototype.slice.call(
      link.querySelectorAll('.sb-agent__toolbelt-frame--tools .sb-agent__toolbelt-row')
    );
    var skillRows = Array.prototype.slice.call(
      link.querySelectorAll('.sb-agent__toolbelt-frame--skills .sb-agent__toolbelt-row')
    );
    var played = false;

    function playSequence() {
      if (played) return;
      played = true;
      lightRows(toolRows, function () {
        window.setTimeout(function () {
          lightRows(skillRows);
        }, SKILLS_DELAY_MS);
      });
    }

    function onInView(entry) {
      if (!entry.isIntersecting) {
        link.classList.remove('is-inview');
        return;
      }
      link.classList.add('is-inview');
      if (!reduceMotion) playSequence();
    }

    if (reduceMotion) {
      link.classList.add('is-inview');
      return;
    }

    if (belowFold(section)) {
      toolRows.concat(skillRows).forEach(function (row) {
        row.classList.add('is-armed');
      });
    } else {
      played = true;
      link.classList.add('is-inview');
    }

    if (!('IntersectionObserver' in window)) {
      link.classList.add('is-inview');
      if (!played) playSequence();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(onInView);
      },
      { threshold: 0.35 }
    );
    observer.observe(section);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.sb-agent__toolbelt-link').forEach(initLink);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
